import { all, call, put, select, takeEvery } from "redux-saga/effects";

import {
  getResponseFileStart,
  getResponseFileSuccess,
  getResponseFileFailed,
} from "../redux/file";
import { getImageResponseApi } from "core/http/service/util";
import { fileResponseSelector } from "../redux/selector";

function* getResponseFileWork(action) {
  const { url, type, callback } = action.payload;
  const responseImage = yield select(fileResponseSelector(url));
  if (responseImage) {
    callback?.(responseImage);
    return;
  }
  try {
    const res = yield call(getImageResponseApi, url, type);

    const buffer = new Uint8Array(res.data);
    const blob = new Blob([buffer], { type });
    const data = URL.createObjectURL(blob);
    yield put({
      type: getResponseFileSuccess.type,
      payload: {
        key: url,
        data: data,
      },
    });
    if (callback) {
      callback(data);
    }
  } catch (error: any) {
    yield put({
      type: getResponseFileFailed.type,
    });
  }
}

function* watchResponseFile() {
  yield takeEvery(getResponseFileStart.type, getResponseFileWork);
}

export default function* getResponseFileSaga() {
  yield all([watchResponseFile()]);
}
